/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useEffect } from 'react';
import { showCustomToast } from '@fff-web/fff-ui-shared';
import { useKeepSubscriptionsDataContext } from '../context/KeepSubscriptionsContext';
import * as styles from './KeepSubscriptions.module.scss';

const ErrorMessage = ({ onRetry }: { onRetry(): void }) => (
  <>
    We’re sorry! Our server has encountered an internal error while fetching your active reFill
    subscriptions. Please{' '}
    {/* TODO: Please fix the a11y issues with this element and then remove the comments at the top of the file. */}
    <span className={styles.textButton} onClick={onRetry}>
      click here
    </span>{' '}
    to try again.{' '}
  </>
);

const useKeepSubscriptionsErrorFallback = () => {
  const { status, refetch } = useKeepSubscriptionsDataContext();

  useEffect(() => {
    if (status !== 'error') return;
    const ErrorMsg = () => <ErrorMessage onRetry={refetch} />;
    showCustomToast('error', 'Server Error', ErrorMsg);
  }, [status, refetch]);

  return;
};

export { useKeepSubscriptionsErrorFallback };
